module.exports = __webpack_public_path__ + "img/shareGreenHoverLighter.3d0f00e8.svg";